import moment from 'moment-timezone'
export default {
  install: function (Vue) {
    Object.defineProperty(Vue.prototype, '$moment', { value: moment })
  }
}
